import { useSettings } from 'shared/utils/useSettings'
import { useOrm } from 'shared/utils/useOrm'
import { useCart } from 'shop-components/utils/useCart'

export const useCannotCheckout = () => {
  const useAvailability = useSettings('store.use_availability')
  const { cart } = useCart()
  const unavailableLines = useOrm('lines', (lines) => {
    return lines
      .getAll({
        id: cart?.lines,
        can_checkout: false
      })
      .filter((line) => line.line_type !== 'delivery_rate')
  })

  const cannotCheckout = useAvailability && unavailableLines.size() > 0

  return cannotCheckout
}
